export default __webpack_public_path__ + "static/media/ic_success_green.effbd704.svg";